import { useQuery } from '@tanstack/react-query';
import { dataCentralApi } from '@/api/client';
import type { ResponseArray } from '@/types/shared';

/**
 * Supplier (partner) options for the contract Custom config picker. Endpoint +
 * field names are the v4 backend's `GET /partners/options` verbatim (legacy
 * `getSupplierOptions`). Used to link a supplier to a customer contract.
 */

export interface PartnerOption {
  partner_id: number;
  partner_name: string;
  partner_code?: string;
}

export const partnerOptionKeys = {
  options: ['partners', 'options'] as const,
};

/** `GET /partners/options` — supplier options for the partner picker. */
export function usePartnerOptions() {
  return useQuery({
    queryKey: partnerOptionKeys.options,
    queryFn: async (): Promise<PartnerOption[]> => {
      const res = await dataCentralApi.get<ResponseArray<PartnerOption>>('/partners/options');
      return res.data.results ?? [];
    },
  });
}
